import WsClient from './ws';
import { EventBus } from './eventBus';

// ===============================
// 🔔 报警类型 → Notification 类型映射
// ===============================
const alarmTypeMap = {
  '紧急求助': 'error',
  '火警': 'error',

  '打架': 'warning',
  '生病': 'warning',

  '人员噪声': 'info',
};

// 默认兜底
const DEFAULT_NOTIFY_TYPE = 'warning';

let wsClient = null;

export function getWsClient(token, callbacks = {}) {
  if (!wsClient) {
    wsClient = new WsClient({
      token,
      ...callbacks
    });
    wsClient.connect();
  } else {
    if (callbacks.onMessage) wsClient.onMessage = callbacks.onMessage;
    if (callbacks.onOpen) wsClient.onOpen = callbacks.onOpen;
    if (callbacks.onClose) wsClient.onClose = callbacks.onClose;
  }
  return wsClient;
}

export function getExistingWsClient() {
  return wsClient;
}

export function closeWsClient() {
  if (wsClient) {
    wsClient.close();
    wsClient = null;
  }
}

// ===============================
// 📤 发送 WebSocket 消息
// ===============================
export function sendMessage(data) {
  if (wsClient && wsClient.ws && wsClient.ws.readyState === WebSocket.OPEN) {
    const payload = typeof data === 'string' ? data : JSON.stringify(data);
    wsClient.ws.send(payload);
    console.log('📤 发送消息:', payload);
  } else {
    console.warn('⚠️ WebSocket 未连接，无法发送');
  }
}

// ===============================
// 🚀 初始化 WS + 报警通知处理
// ===============================
export function setupWsClientWithNotification(token) {
  getWsClient(token, {
    onMessage: (message) => {
      let parsedMessage;

      // 统一 JSON 解析
      if (typeof message === 'string') {
        try {
          parsedMessage = JSON.parse(message);
        } catch (error) {
          console.error('❌ WebSocket 消息解析失败:', message);
          return;
        }
      } else {
        parsedMessage = message;
      }

      // 分发所有 WS 消息
      EventBus.$emit('ws-message', parsedMessage);

      // =========================
      // 🔔 处理报警通知
      // =========================
      if (parsedMessage.type === 'notification' && parsedMessage.data) {
        const {
          alarmType,
          alarmMessage,
          alarmTime,
          status,
          alarmCode, // ⚠️ 预留：如果后端以后加
        } = parsedMessage.data;

        if (status !== '未处理') return;

        // 🔥 决定通知类型
        const notifyType =
          alarmTypeMap[alarmType] ||
          alarmTypeMap[alarmCode] ||
          DEFAULT_NOTIFY_TYPE;

        EventBus.$emit('show-notification', {
          title: notifyType === 'error' ? '严重警告' : '警告',
          message: `
            报警类型: ${alarmType}<br>
            报警信息: ${alarmMessage}<br>
            触发时间: ${alarmTime}
          `,
          type: notifyType,
          offset: 45,
          dangerouslyUseHTMLString: true,
          duration: 0, // 不自动关闭
        });
      }
    },

    onOpen: () => {
      console.log('✅ WebSocket 连接已打开');
    },

    onClose: (event) => {
      console.warn(
        `⚠️ WebSocket 已关闭，code=${event.code}, reason=${event.reason || '无'}`
      );

      if (event.code === 1006) {
        console.error('❌ WebSocket 异常断开');
      } else if (event.code === 1000) {
        console.log('ℹ️ WebSocket 正常关闭');
      }
    }
  });
}
